import type { SvgIconComponent } from '@mui/icons-material'
import type { ElementType } from 'react'
import { IconButton, type IconButtonProps } from '@mui/material'

type BorderedIconButtonProps = Omit<IconButtonProps, 'children'> & {
  Icon: SvgIconComponent
  label: string
  // IconButton does not type polymorphic props (component/to) on its own
  component?: ElementType
  to?: string
}

export const BorderedIconButton = ({ Icon, label, sx, ...rest }: BorderedIconButtonProps) => (
  <IconButton
    size="large"
    {...rest}
    aria-label={label}
    title={label}
    sx={{ border: 1, borderColor: 'divider', ...sx }}
  >
    <Icon />
  </IconButton>
)
